module.exports = require('../ifCond').ifCondHelper;
